import { useEffect, useRef, useState } from 'react'

export interface FileWithSrc {
  file?: File
  src?: string
}

export default function useFileInput() {
  const inputRef = useRef<HTMLInputElement>()
  const [file, setFile] = useState<FileWithSrc>(null)

  function handleChange() {
    const uploadedFile = inputRef.current.files[0]
    if (!uploadedFile) return

    const src = URL.createObjectURL(uploadedFile)

    setFile({
      file: uploadedFile,
      src,
    })
  }

  function removeFile() {
    setFile(null)
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  useEffect(() => {
    if (!inputRef?.current) {
      return
    }

    inputRef.current.addEventListener('change', handleChange)
    return () => inputRef?.current?.removeEventListener('change', handleChange)
  }, [inputRef.current])

  return { inputRef, file, removeFile }
}
